const mutations = {
  switchLoading (state, value) {
    state.isLoading = value
  },

  setStep (state, value) {
    state.step = value
  },

  setModel (state, value) {
    state.model = value
  },

  setClouds (state, value) {
    state.clouds = value
  },

  setAnimationPlaying (state, value) {
    state.animationPlaying = value
  },

  setIpData (state, value) {
    state.ipData = value
  },

  resetIpData (state) {
    state.ipData = []
  }
}

export default mutations
